import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

// Frontend-managed "Pick for" descriptions shown in the InfoTooltip.
// Both group-level and variant-level entries return a key that resolves to a
// localized string at render time. The literal "Pick for:" prefix lives on the
// tooltip label itself — the strings here are just the predicate.
//
// Group keys mirror IAIVideoModel.code.
// Variant keys mirror IAIVideoModel.model (selectKey).

export const getGroupDescription = (groupKey: string): string => {
  switch (groupKey) {
    case 'renderforest':
      return translate(T.VIDEO_PICK_FOR_RENDERFOREST)
    case 'bytePlus':
      return translate(T.VIDEO_PICK_FOR_SEEDANCE)
    case 'pixVerse':
      return translate(T.VIDEO_PICK_FOR_PIXVERSE)
    case 'kling':
      return translate(T.VIDEO_PICK_FOR_KLING)
    case 'google':
      return translate(T.VIDEO_PICK_FOR_VEO)
    case 'openAi':
      return translate(T.VIDEO_PICK_FOR_SORA)
    case 'miniMax':
      return translate(T.VIDEO_PICK_FOR_HAILUO)
    default:
      return ''
  }
}

export const getVariantDescription = (selectKey: string): string => {
  switch (selectKey) {
    case 'forest-1.0-pro':
      return translate(T.VIDEO_PICK_FOR_RENDERFOREST_PRO)
    case 'forest-1.0':
      return translate(T.VIDEO_PICK_FOR_RENDERFOREST_FAST)
    case 'seedance-1.5-pro':
      return translate(T.VIDEO_PICK_FOR_SEEDANCE_1_5_PRO)
    case 'dreamina-seedance-2.0':
      return translate(T.VIDEO_PICK_FOR_SEEDANCE_2_0)
    case 'dreamina-seedance-2.0-fast':
      return translate(T.VIDEO_PICK_FOR_SEEDANCE_2_0_FAST)
    case 'pixverse-v5':
      return translate(T.VIDEO_PICK_FOR_PIXVERSE_V5)
    case 'pixverse-v6':
      return translate(T.VIDEO_PICK_FOR_PIXVERSE_V6)
    case 'pixverse-c1':
      return translate(T.VIDEO_PICK_FOR_PIXVERSE_C1)
    case 'kling-v3-omni':
      return translate(T.VIDEO_PICK_FOR_KLING_3_OMNI)
    case 'kling-v3-omni-with-sound':
      return translate(T.VIDEO_PICK_FOR_KLING_3_OMNI_AUDIO)
    case 'kling-v2.6':
      return translate(T.VIDEO_PICK_FOR_KLING_2_6)
    default:
      return ''
  }
}
